import { reduxForm } from 'redux-form';
import { compose } from 'redux';

import { connect } from 'react-redux';

import { withIntl } from 'HOC/withIntl';
import shouldSubmit from 'utilities/shouldSubmit';
import getDefaultLanguageRequiredFieldsErrors from 'utilities/getDefaultLanguageRequiredFieldsErrors';

import NewsForm from '../components/NewsForm';

import { updateNewsRequest } from '../services/actions';
import { selectNewsForUpdate } from '../services/selectors';
import { forms, localizableFields, requiredFields } from '../services/config';

const form = forms.updateNewsForm;

const validate = (values, { intl }) =>
    getDefaultLanguageRequiredFieldsErrors(values, requiredFields, intl.formatMessage({ id: 'error.required' }));

const onSubmit = (data, dispatch, { intl, id }) => {
    const confirmMessage = intl.formatMessage({ id: 'alert.submit.warn' });
    if (shouldSubmit(data, localizableFields, confirmMessage)) {
        dispatch(updateNewsRequest(form, id, data));
    }
};

export default compose(
    withIntl,
    connect((state, { id, delayed }) => ({
        initialValues: selectNewsForUpdate(state, { id, delayed }),
    })),
    reduxForm({
        form,
        validate,
        onSubmit,
        enableReinitialize: true,
    }),
)(NewsForm);
